<!-- Hero Section -->
<section class="relative overflow-hidden pt-20 pb-32 lg:pt-32 lg:pb-48 bg-surface">
<div class="max-w-screen-2xl mx-auto px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
<div class="z-10">
<span class="inline-block py-1 px-3 rounded-full bg-secondary-container text-on-secondary-container text-xs font-bold mb-6 tracking-wider uppercase">Enterprise Ready</span>
<h1 class="text-5xl lg:text-7xl font-extrabold tracking-tight text-on-surface mb-8 leading-[1.1]">Complete Control Over Your <span class="text-primary">Car Rental</span><span class="text-primary text-7xl">.</span></h1>
<p class="text-xl text-on-surface-variant mb-12 max-w-xl leading-relaxed">From fleet management to automated bookings, and real-time tracking - manage your rental lifecycle in one place.</p>
<div class="flex flex-wrap gap-4">
<a routerLink="/create-account" class="bg-gradient-to-r from-primary to-primary-container text-on-primary px-8 py-4 rounded-xl font-bold text-lg shadow-xl hover:shadow-primary/20 transition-all active:scale-95">Get Started</a>
<a class="bg-surface-container-high text-on-primary-fixed-variant px-8 py-4 rounded-xl font-bold text-lg hover:bg-surface-container-highest transition-all active:scale-95" href="#">Watch Demo</a>
</div>
</div>
<div class="relative">
<div class="absolute -top-20 -right-20 w-96 h-96 bg-primary/10 rounded-full blur-3xl"></div>
<div class="relative bg-surface-container-lowest rounded-2xl p-4 shadow-[0_12px_40px_rgba(25,28,30,0.06)] transform lg:rotate-2 lg:hover:rotate-0 transition-transform duration-500">
<img alt="Fleet Dashboard" class="rounded-xl w-full h-auto object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBlGpt1GGNPOwtVLEausS4g9ZUQ6ZXgiiopoJRVpu8FNuOw7s6do2PPXdgtsvZRqcqmPXWykYZTdoS5qRyMd_f9oaVpNb-E8jyBd0xd9RB6Hm9aYj5340vcZhZtO0zwjkJjkMGE0Q8-F6tPu2FZ18lx69Lc7KjNg9Ci1SW_NTSvi4pb4hgZfLLsLr2msA229vPVgYakbcNAvulgoUqo815ahBkH1WjWcd6BDvt14A8zdvVFiHH8wpxRLmJPG27nIJyDhwEdq6f85xk"/>
</div>
</div>
</div>
</section>

<!-- Bento Grid -->
<section class="py-24 bg-surface-container-low">
<div class="max-w-screen-2xl mx-auto px-8">
<div class="text-center mb-16">
<h2 class="text-4xl font-extrabold mb-4">Next-Gen Vehicle Rental Management Software</h2>
<p class="text-on-surface-variant max-w-2xl mx-auto">Our <b>all-in-one vehicle rental module</b> synchronizes every aspect of your operations.</p>
</div>
<div class="grid grid-cols-1 md:grid-cols-3 gap-6">
<div class="md:col-span-2 bg-surface-container-lowest p-10 rounded-xl shadow-sm hover:shadow-md transition-shadow">
<span class="material-symbols-outlined text-4xl text-primary mb-6">layers</span>
<h3 class="text-2xl font-bold mb-4">Paperless Contract Management</h3>
<p class="text-on-surface-variant leading-relaxed">Generate digital rental agreements and invoices with integrated e-signature support for a 100% digital workflow.</p>
</div>
<div class="bg-primary p-10 rounded-xl shadow-xl text-on-primary flex flex-col justify-between">
<div>
<span class="material-symbols-outlined text-4xl mb-6">qr_code_2</span>
<h3 class="text-2xl font-bold mb-4">Real-Time Monitoring</h3>
<p class="text-primary-fixed leading-relaxed">Gain instant visibility into "Available," "On-Rent," and "In-Service" statuses.</p>
</div>
</div>
</div>
</div>
</section>
<!-- Dynamic Pricing Engine -->
<section class="py-24 bg-surface">
<div class="max-w-screen-2xl mx-auto px-8 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
<div class="order-2 lg:order-1">
<div class="bg-surface-container-lowest rounded-2xl p-8 shadow-[0_12px_40px_rgba(25,28,30,0.06)]">
<div class="flex items-center justify-between mb-8">
<h4 class="font-bold text-lg">December 2024</h4>
<div class="flex gap-2">
<span class="material-symbols-outlined cursor-pointer">chevron_left</span>
<span class="material-symbols-outlined cursor-pointer">chevron_right</span>
</div>
</div>
<div class="grid grid-cols-7 gap-4 mb-4 text-center text-xs font-bold text-on-surface-variant">
<span>M</span><span>T</span><span>W</span><span>T</span><span>F</span><span>S</span><span>S</span>
</div>
<div class="grid grid-cols-7 gap-4">
<div class="aspect-square bg-surface-container-low rounded-lg flex flex-col items-center justify-center"><span class="text-xs">20</span><span class="text-[10px] text-on-secondary-container font-bold">$99</span></div>
<div class="aspect-square bg-surface-container-low rounded-lg flex flex-col items-center justify-center"><span class="text-xs">21</span><span class="text-[10px] text-on-secondary-container font-bold">$99</span></div>
<div class="aspect-square bg-secondary-container rounded-lg flex flex-col items-center justify-center"><span class="text-xs text-on-secondary-container font-bold">22</span><span class="text-[10px] text-on-secondary-container font-bold">$149</span></div>
<div class="aspect-square bg-secondary-container rounded-lg flex flex-col items-center justify-center"><span class="text-xs text-on-secondary-container font-bold">23</span><span class="text-[10px] text-on-secondary-container font-bold">$149</span></div>
<div class="aspect-square bg-secondary-container rounded-lg flex flex-col items-center justify-center"><span class="text-xs text-on-secondary-container font-bold">24</span><span class="text-[10px] text-on-secondary-container font-bold">$199</span></div>
<div class="aspect-square bg-error-container rounded-lg flex flex-col items-center justify-center"><span class="text-xs text-on-error-container font-bold">25</span><span class="text-[10px] text-on-error-container font-bold">Booked</span></div>
<div class="aspect-square bg-surface-container-low rounded-lg flex flex-col items-center justify-center"><span class="text-xs">26</span><span class="text-[10px] text-on-secondary-container font-bold">$119</span></div>
</div>
</div>
</div>
<div class="order-1 lg:order-2">
<h2 class="text-4xl font-extrabold mb-8">Maximize Revenue with Dynamic Pricing</h2>
<p class="text-lg text-on-surface-variant mb-8 leading-relaxed">Configure custom rate structures based on multi-tier rates: Hourly, Daily, Weekly, Monthly, and Yearly.</p>
</div>
</div>
</section>

<!-- Live Availability Tracking -->
<section class="py-24 bg-surface-container-low">
<div class="max-w-screen-2xl mx-auto px-8">
<div class="flex flex-col lg:flex-row justify-between items-end mb-16 gap-8">
<div class="max-w-xl">
<h2 class="text-4xl font-extrabold mb-4">Real-Time Operational Visibility</h2>
<p class="text-on-surface-variant">Transform raw data into actionable strategy with <b>Advanced Reporting</b> and interactive visuals.</p>
</div>
</div>
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
  <div *ngFor="let v of vehicles" class="bg-surface-container-lowest p-6 rounded-xl shadow-sm">
    <div class="flex justify-between items-center mb-6">
      <span class="text-xs font-bold text-on-surface-variant uppercase tracking-widest">{{v.category}} #{{v.assetCode}}</span>
      <span class="px-2 py-0.5 text-[10px] font-bold rounded-full" [ngClass]="getStatusBadgeClass(v.status)">{{v.status}}</span>
    </div>
    <h4 class="font-bold text-lg mb-1">{{v.name}}</h4>
    <p class="text-sm text-on-surface-variant mb-6">{{v.location}} &bull; {{v.details}}</p>
    <div class="h-2 rounded-full w-full" [ngClass]="getStatusBarClass(v.status)"></div>
  </div>
</div>
</div>
</section>

<!-- Industry and FAQ -->
<section class="py-24 bg-surface-container-highest">
<div class="max-w-screen-2xl mx-auto px-8 text-center mb-20">
<h2 class="text-4xl font-extrabold mb-4">Why Choose Our Vehicle Rental Solution?</h2>
</div>
</section>

<section class="py-24 bg-surface-container-low font-['Manrope']">
<div class="max-w-3xl mx-auto px-8">
<div class="text-center mb-16">
<h2 class="text-4xl font-extrabold mb-4">Frequently Asked Questions</h2>
</div>
<div class="space-y-4">
  <details *ngFor="let faq of faqs" class="faq-accordion group bg-surface-container-lowest rounded-2xl shadow-sm overflow-hidden border border-transparent hover:border-outline-variant transition-all duration-300">
    <summary class="flex justify-between items-center p-6 cursor-pointer list-none">
    <h3 class="text-lg font-bold text-on-surface">{{faq.question}}</h3>
    <span class="faq-icon material-symbols-outlined text-primary transition-transform duration-300">expand_more</span>
    </summary>
    <div class="px-6 pb-6 text-on-surface-variant leading-relaxed">{{faq.answer}}</div>
  </details>
</div>
</div>
</section>
